var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BFormInput',{staticClass:"search",attrs:{"size":"sm","value":_vm.value,"placeholder":`${_vm.$t('general.search')}...`,"type":"search"},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }